<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="edit-outline" *ngIf="action === 'edit'"></nb-icon>
        <nb-icon icon="plus-outline" *ngIf="action !== 'edit'"></nb-icon>
        <div class="ml-2" *ngIf="action === 'edit'" i18n>Editing Insight: {{ insight.id }}</div>
        <div class="ml-2" *ngIf="action === 'clone'" i18n>Cloning Insight</div>
        <div class="ml-2" *ngIf="action === 'create'" i18n>Creating Insight</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>Insight Details</strong>
    <hr />
    <form #insightForm="ngForm">
      <div class="row">
        <div class="col-4">
          <label i18n>Insight Category<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <ng-select
            id="category"
            name="category"
            placeholder="Select Category"
            i18n-placeholder
            [(ngModel)]="insight.category"
            required
            #category="ngModel"
          >
            <ng-option *ngFor="let category of categories" [value]="category">
              {{ category | replaceunderscore | titlecase }}</ng-option
            >
          </ng-select>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4">
          <label i18n>Insight Name<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <input
            id="name"
            ngbAutofocus
            [(ngModel)]="insight.name"
            class="form-control form-control-sm"
            type="text"
            placeholder="Insight Name"
            i18n-placeholder
            name="name"
            #name="ngModel"
            required
            nbInput
            style="width: 100%"
            [appValidRegex]="thisRegex"
          />
          <div *ngIf="(name?.touched || name?.dirty) && name?.errors?.required" class="validation-message" i18n>
            Name is a required field.
          </div>
          <div *ngIf="name.errors?.validRegex" class="validation-message" i18n>
            The first character must be alphanumeric, and up to 128 letters (uppercase and lowercase), numbers, hyphens,
            and underscores are allowed.
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4"><label i18n>Description:</label></div>
        <div class="col-8">
          <textarea
            id="description"
            name="description"
            [(ngModel)]="insight.description"
            nbInput
            fullWidth
            placeholder="Description"
            i18n-placeholder
            style="width: 100%"
          ></textarea>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4"><label i18n>Trigger Query</label></div>
        <div class="col-8">
          <!-- <p>
              <i
                >Press F11 when cursor is in the editor to toggle full screen
                editing. F11 can also be used to exit full screen editing.</i
              >
            </p>
            <br /> -->
          <ngx-codemirror
            #codeeditor
            id="query"
            name="query"
            [(ngModel)]="insight.query"
            [options]="{
              lineNumbers: true,
              theme: 'default',
              mode: 'sql'
            }"
          ></ngx-codemirror>
        </div>
      </div>
      <br />
      <strong class="text-uppercase" i18n>Actions Details</strong>
      <hr />
      <div class="row">
        <div class="col-4"><label i18n>Activated</label></div>
        <div class="col-8">
          <nb-checkbox
            id="enabled"
            name="enabled"
            (checkedChange)="checkedActivated()"
            [(ngModel)]="insight.enabled"
          ></nb-checkbox>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4"><label i18n>Schedule</label></div>
        <div class="col-8">
          <nb-select
            placeholder="Select Frequency"
            i18n-placeholder
            [(ngModel)]="insight.schedule_seconds"
            id="schedule_seconds"
            name="schedule_seconds"
            style="width: 100%"
          >
            <nb-option *ngFor="let frequency of FREQUENCIES" [value]="frequency.value">
              {{ frequency.label }}
            </nb-option>
          </nb-select>
        </div>
      </div>
      <br />
    </form>
    <div *ngIf="showDatepicker" class="row">
      <div class="col-4"><label i18n>Start Time:</label></div>
      <div class="col-8">
        <div class="picker-row">
          <input
            id="start"
            nbInput
            [(ngModel)]="dateForDatepickerStart"
            required
            [owlDateTime]="startPicker"
            [min]="minStartDate"
            [owlDateTimeTrigger]="startPicker"
            (ngModelChange)="changeEvent()"
            placeholder="Select Start Time"
            i18n-placeholder
          />
          <owl-date-time #startPicker></owl-date-time>
        </div>
      </div>
    </div>
    <br />

    <div *ngIf="showDatepicker" class="row">
      <div class="col-4"><label i18n>End Time:</label></div>
      <div class="col-8">
        <div class="picker-row">
          <input
            id="end"
            nbInput
            [(ngModel)]="dateForDatepickerEnd"
            required
            [owlDateTime]="endPicker"
            [min]="minEndDate"
            [owlDateTimeTrigger]="endPicker"
            (ngModelChange)="changeEvent()"
            placeholder="Select End Time"
            i18n-placeholder
          />
          <owl-date-time #endPicker></owl-date-time>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="close()" i18n>Close</button>
      <button nbButton class="ml-3" status="success" (click)="save()" [disabled]="!insightForm.form.valid" i18n>
        Save
      </button>
    </div>
  </nb-card-footer>
</nb-card>
